import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import {BrgIconErrorSearchResults} from '~/icons/brg-icon-error-search-results'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const SearchBoxDropdownError = () => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  return (
    <div className="mb-1 flex flex-col items-center justify-center space-y-1 py-1 text-center last:mb-0 [&>*]:px-8 [&>svg]:h-28 [&>svg]:w-full">
      <BrgIconErrorSearchResults />
      <span className="text-lg font-bold text-black">{translations.CategorySearchCombo.Error.title}</span>
      <span className="text-sm font-light text-gray-600">{translations.CategorySearchCombo.Error.subtitle}</span>
    </div>
  )
}

export default SearchBoxDropdownError
